export default __webpack_public_path__ + "static/media/AK-CF-thru-12.31.2021-10000978.03e0b277.pdf";